module.exports = __webpack_public_path__ + "static/img/model-bg38.d2c0994.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg38.jpg
// module id = LCGC
// module chunks = 0